import { AxiosInstance } from 'axios';
import ShiftNoteRepositoryInterface, { ApiCreateShiftNoteInterface, ShiftNoteInterface } from '@/services/Calendar/ShiftNote/Interfaces';

export default class ShiftNoteRepository implements ShiftNoteRepositoryInterface {
  private apiPrefix = '/calendar/shifts/note';

  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllShiftNotes(): Promise<ShiftNoteInterface[]> {
    const res = await this.axios.get(this.apiPrefix);

    return res.data;
  }

  public async createShiftNote(data: ApiCreateShiftNoteInterface): Promise<boolean> {
    const res = await this.axios.post(this.apiPrefix, data);

    return res.status === 201;
  }

  public async deleteShiftNote(departmentId: string): Promise<void> {
    await this.axios.delete(this.apiPrefix, { data: { id: departmentId } });
  }
}
